/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { AlertServiceService } from '../../alert/shared/service/alert-service.service';
import { AppUtilityService } from './app-utility.service';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { CommonPickListService } from './common-picklist.service';
import { DataStoreService } from './datastore.service';
import { Injectable } from '@angular/core';
import { LmsEventDetails } from '../model/lms-event-details.model';
import { LmsLoaderService } from './lms-loader.service';
import { MasterDataService } from './master-data.service';
import { Router } from '@angular/router';
import { StaticDataStoreService } from './../../core/services/static-datastore.service';
import { Tab } from './../model/tab.model';
import { TabService } from './tab.service';
import { UserPrefWindow } from './../model/user-pref-window-model';
import { UserProfileService } from './user-profile.service';
import { UserService } from './user.service';
import { environment } from './../../../environments/environment';

/**
 * @export
 * @class SystemInitService
 */
@Injectable()
export class SystemInitService {
    localStorageTab;
    localStorageData;
    isLocalTabNotExist: boolean;

    userPrefLoad: Observable<boolean>;
    private userPrefLoadBS: BehaviorSubject<boolean>;

    /**
     * Creates an instance of SystemInitService.
     * @param {TabService} tabService
     * @param {UserService} userService
     * @param {LmsLoaderService} lmsLoaderService
     * @param {UserProfileService} userProfileService
     * @param {DataStoreService} dataStoreService
     * @param {Router} router
     * @param {CommonPickListService} CommonPickListService
     * @param {StaticDataStoreService} staticDataStoreService
     *
     * @memberOf SystemInitService
     */
    constructor(private tabService: TabService,
        private userService: UserService,
        private lmsLoaderService: LmsLoaderService,
        private userProfileService: UserProfileService,
        private dataStoreService: DataStoreService,
        private router: Router,
        private alertService: AlertServiceService,
        private commonPickListService: CommonPickListService,
        private masterDataService: MasterDataService,
        private staticDataStoreService: StaticDataStoreService,
        private appUtilService: AppUtilityService) {
        this.userPrefLoadBS = <BehaviorSubject<boolean>>new BehaviorSubject({});
        this.userPrefLoad = this.userPrefLoadBS.asObservable();
    }

    /**
     * This is used to load all the services like user , Common services etc
     * @memberOf SystemInitService
     */
    init() {
        if (window.location.href.indexOf('?') > -1) {
            this.staticDataStoreService.putValue('BASE_HREF', window.location.href.substring(0, window.location.href.indexOf('?')));
        } else {
            this.staticDataStoreService.putValue('BASE_HREF', window.location.href);
        }

        switch (this.getParameterByName('showHeader')) {
            case 'false':
                this.staticDataStoreService.putValue('SHOW_HEADER', false);
                break;
            default:
                this.staticDataStoreService.putValue('SHOW_HEADER', true);
                break;
        }

        this.localStorageTab = localStorage.getItem('localTab');
        localStorage.removeItem('localTab');
        this.isLocalTabNotExist = _.isEmpty(this.localStorageTab);
        if (!this.isLocalTabNotExist) {
            this.localStorageTab = JSON.parse(this.localStorageTab);
            this.localStorageData = this.localStorageTab.dropData;
            delete this.localStorageTab.dropData;
        }
        this.lmsLoaderService.showLoader();

        // this.loadMasterData();
        this.userService.getData().subscribe(userData => {
            this.userService.load(userData);
            this.loadMasterData();
        }, error => {
            this.lmsLoaderService.hideLoader();
            this.userService.handleLoadError(error);
        });

    }

    /**
     * Load Common Asyc service when system init.
     * @private
     * @memberOf SystemInitService
     */
    private loadMasterData() {
        this.masterDataService.getData().subscribe(finalRespopnse => {
            this.masterDataService.load(finalRespopnse);
            if (this.isLocalTabNotExist) {
                this.checkUrlParameters();
            } else {
                this.lmsLoaderService.hideLoader();
                this.dataStoreService.putValue(this.localStorageTab, this.localStorageData);
                this.tabService.copyTab(this.localStorageTab);
            }
            this.userPrefLoadBS.next(true);
        }, error => {
            this.lmsLoaderService.hideLoader();
            this.masterDataService.handleError(error);
        });
    }

    /**
     * set tabs when user preferences exist.
     * @private
     * @memberOf SystemInitService
     */
    private setTabs() {
        const userProfile = this.staticDataStoreService.getValue('userProfile');
        const managerDesk = this.staticDataStoreService.getValue('commonopsPicklist');
        let windowPrefExist = false;
        if (userProfile && userProfile.alertType) {
            this.tabService.removeTabs();
            const tabsdata: Array<Tab> = [];
            if (userProfile.alertType !== 'NON') {
                const alertTab = <Tab>({
                    type: 'Alerts',
                    subType: 'Data',
                    selected: false
                });
                alertTab.id = new Date().getTime();
                alertTab.subTypeDetail = {};
                alertTab.subTypeDetail[alertTab.subType.toLowerCase()] = {};
                alertTab.subTypeDetail[alertTab.subType.toLowerCase()].message = '';
                alertTab.subTypeDetail[alertTab.subType.toLowerCase()].status = 'blank';
                this.tabService.notifyChange(<LmsEventDetails>({
                    type: 'add',
                    data: alertTab
                }));
                this.alertService.init(alertTab);
            }
            if (userProfile.userPrefWindowList && userProfile.userPrefWindowList.length > 0) {
                windowPrefExist = true;
                const tabPreferences = new Array<Tab>();
                let firstTabPreference: Tab;
                for (let i = 0; i < userProfile.userPrefWindowList.length; i++) {
                    const userPrefWindow: UserPrefWindow = userProfile.userPrefWindowList[i];
                    if (userPrefWindow && userPrefWindow.windowName) {
                        const windowArr = _.split(userPrefWindow.windowName, ' ');
                        const newTab = <Tab>({
                            type: windowArr[0],
                            subType: windowArr[1]
                        });
                        newTab.subTypeDetail = {};
                        newTab.subTypeDetail[windowArr[1].toLowerCase()] = {};
                        newTab.subTypeDetail[windowArr[1].toLowerCase()].message = '';
                        newTab.subTypeDetail[windowArr[1].toLowerCase()].status = '';

                        newTab.tabSearchParameter = {};
                        if (userPrefWindow.windowName === 'Outlying-Points Data') {
                            if (userPrefWindow.deskName) {
                                newTab.tabSearchParameter.searchText = userPrefWindow.deskName;
                            } else {
                                let isDeskPresent = false;
                                if (managerDesk && managerDesk.masterData) {
                                    for (let j = 0; j < managerDesk.masterData.zoneList.length; j++) {
                                        if (userProfile.alertDesk && userProfile.alertDesk.trim().toLowerCase() === managerDesk.masterData.zoneList[j].zoneCode.trim().toLowerCase()) {
                                            isDeskPresent = true;
                                            break;
                                        }
                                    }
                                }
                                if (isDeskPresent) {
                                    newTab.tabSearchParameter.searchText = userProfile.alertDesk;
                                }
                            }
                        } else {
                            if (userPrefWindow.terminalMnemonic) {
                                newTab.tabSearchParameter.searchText = userPrefWindow.terminalMnemonic;
                            }
                        }

                        if (userPrefWindow.noThroughTrains &&
                            userPrefWindow.noThroughTrains.trim().toUpperCase() === 'Y') {
                            newTab.tabSearchParameter.noThroughTrains = true;
                        } else {
                            newTab.tabSearchParameter.noThroughTrains = false;
                        }
                        if (!firstTabPreference) {
                            firstTabPreference = newTab;
                        } else {
                            tabPreferences.push(newTab);
                        }
                    }
                }
                this.tabService.bulkTabCreation(tabPreferences, firstTabPreference);
            } else {
            }
        } else {
        }
        if (!windowPrefExist) {
            this.router.navigateByUrl(`/terminal/status/${new Date().getTime()}`, { skipLocationChange: environment.hideUrl });
        }
    }

    /**
     * this method gets the value of Query Parameter from Url
     * @private
     * @param {string} name
     * @param {string} [url]
     * @returns
     * @memberof SystemInitService
     */
    private getParameterByName(name: string, url?: string) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) { return null; };
        if (!results[2]) { return ''; };
        return decodeURIComponent(results[2].replace(/\+/g, ' ')).trim().toLowerCase();
    }

    /**
     * this method opens the Window according to Query Parameters
     * @memberof SystemInitService
     */
    checkUrlParameters() {
        switch (this.getParameterByName('type')) {
            case 'terminal':
                this.routeToTerminal();
                break;
            case 'locomotive':
                this.routeToLocomotive();
                break;
            case 'train':
                this.routeToTrain();
                break;
            case 'locomotive-status':
                this.routeToLocomotiveStatus();
                break;
            case 'yard-local':
                this.routeToYardNLocal();
                break;
            case 'outlying-points':
                this.routeToOutlyingPoint();
                break;
            case 'query-view':
                this.routeToQueryView();
                break;
            default:
                this.setTabs();
                break;
        }
    }

    /**
     * Route to Yard N Local
     * @private
     * @memberof SystemInitService
     */
    private routeToYardNLocal() {
        if (this.getParameterByName('div')) {
            const mnemonic = this.getValidAllocationStation(this.getParameterByName('div'), this.getParameterByName('alocstn'));
            if (this.getParameterByName('alocstn') && mnemonic) {
                this.router.navigateByUrl(
                    `yard-local/data/${new Date().getTime()}?division=${this.getParameterByName('div').toUpperCase()}&allocationStation=${mnemonic.toUpperCase()}`,
                    { skipLocationChange: environment.hideUrl });
            } else {
                this.router.navigateByUrl(
                    `yard-local/data/${new Date().getTime()}?division=${this.getParameterByName('div').toUpperCase()}`,
                    { skipLocationChange: environment.hideUrl });
            }
        } else {
            this.router.navigateByUrl(
                `yard-local/data/${new Date().getTime()}`,
                { skipLocationChange: environment.hideUrl });
        }
    }

    private getValidAllocationStation(division: string, allocationStation: string) {
        if (!this.appUtilService.isValidAllocationStation(division.trim().toUpperCase(), allocationStation.trim().toUpperCase())) {
            const mnemonic = this.appUtilService.getValueForMnemonicMilepost(allocationStation.trim().toUpperCase());
            if (this.appUtilService.isValidAllocationStation(division.trim().toUpperCase(), mnemonic.trim().toUpperCase())) {
                return mnemonic;
            }
        } else {
            return allocationStation;
        }
        return null;
    }

    /**
     * Route to Outyling Point
     * @private
     * @memberof SystemInitService
     */
    private routeToOutlyingPoint() {
        if (this.getParameterByName('desk')) {
            this.router.navigateByUrl(
                `outlying-points/data/${new Date().getTime()}?search=${this.getParameterByName('desk').toUpperCase()}`,
                { skipLocationChange: environment.hideUrl });
        } else {
            this.router.navigateByUrl(
                `outlying-points/data/${new Date().getTime()}`,
                { skipLocationChange: environment.hideUrl });
        }
    }

    /**
     * Route to Locomotive Status
     * @private
     * @memberof SystemInitService
     */
    private routeToLocomotiveStatus() {
        this.router.navigateByUrl(
            `locomotive-status/data/${new Date().getTime()}`,
            { skipLocationChange: environment.hideUrl });
    }

    /**
     * Route To Query View
     * @private
     * @memberof SystemInitService
     */
    private routeToQueryView() {
        this.router.navigateByUrl(
            `query-view/data/${new Date().getTime()}`,
            { skipLocationChange: environment.hideUrl });
    }

    /**
     *  Route To Locomotive
     * @private
     * @memberof SystemInitService
     */
    private routeToLocomotive() {
        switch (this.getParameterByName('subtype')) {
            case 'data':
                this.routeToTab('locomotive/data/');
                break;
            case 'history':
                this.routeToTab('locomotive/history/');
                break;
            case 'notes':
                this.routeToTab('locomotive/notes/');
                break;
            default:
                this.setTabs();
                break;
        }
    }

    /**
     *  Route To Terminal
     * @private
     * @memberof SystemInitService
     */
    private routeToTerminal() {
        switch (this.getParameterByName('subtype')) {
            case 'status':
                this.routeToTab('terminal/status/');
                break;
            case 'handling':
                this.routeToTab('terminal/handling/');
                break;
            case 'notes':
                this.routeToTab('terminal/notes/');
                break;
            default:
                this.setTabs();
                break;

        }
    }

    /**
     * Route To Tab
     * @param {string} [tab]
     * @memberof SystemInitService
     */
    routeToTab(tab?: string) {
        if (this.getParameterByName('search')) {
            let searchText = '';
            let terminalSearchThroughTrainsText = '';
            let terminalSearchSpinnerValText = '';
            if (this.getParameterByName('type').trim().toLowerCase() === 'terminal') {
                searchText = this.appUtilService.getValueForMnemonicMilepost(this.getParameterByName('search').trim().toUpperCase());
                
                if (this.getParameterByName('noThroughTrains')){
                        terminalSearchThroughTrainsText = '&noThroughTrains=' + this.getParameterByName('noThroughTrains')
                }
                if (this.getParameterByName('spinnerVal')){
                        terminalSearchSpinnerValText = '&spinnerVal=' + this.getParameterByName('spinnerVal')
                }

            } else {
                searchText = this.getParameterByName('search').trim().toUpperCase();
            }
            this.router.navigateByUrl(
                `${tab}${new Date().getTime()}?search=${searchText}${terminalSearchThroughTrainsText}${terminalSearchSpinnerValText}`,
                { skipLocationChange: environment.hideUrl });
        } else {
            this.router.navigateByUrl(
                `${tab}${new Date().getTime()}`,
                { skipLocationChange: environment.hideUrl });
        }
    }

    /**
     * Route To train
     * @private
     * @memberof SystemInitService
     */
    private routeToTrain() {
        switch (this.getParameterByName('subtype')) {
            case 'data':
                this.routeToTab('train/data/');
                break;
            case 'history':
                this.routeToTab('train/history/');
                break;
            case 'notes':
                this.routeToTab('train/notes/');
                break;
            case 'profile':
                this.routeToTab('train/profile/');
                break;
            default:
                this.setTabs();
                break;
        }
    }
}
